import serverConfigCTMLocal from './ctm/server_config.local.json';
import serverConfigCTMDev from './ctm/server_config.dev.json';
import serverConfigCTMPartner from './ctm/server_config.partner.json';
import serverConfigCTMUat from './ctm/server_config.uat.json';
import serverConfigCTMPreprod from './ctm/server_config.preprod.json';
import serverConfigCTMProd from './ctm/server_config.prod.json';

import serverConfigCHOOLocal from './choo/server_config.local.json';
import serverConfigCHOODev from './choo/server_config.dev.json';
import serverConfigCHOOPartner from './choo/server_config.partner.json';
import serverConfigCHOOUat from './choo/server_config.uat.json';
import serverConfigCHOOPreprod from './choo/server_config.preprod.json';
import serverConfigCHOOProd from './choo/server_config.prod.json';

import serverConfigISLTLocal from './islt/server_config.local.json';
import serverConfigISLTDev from './islt/server_config.dev.json';
import serverConfigISLTPartner from './islt/server_config.partner.json';
import serverConfigISLTUat from './islt/server_config.uat.json';
import serverConfigISLTProd from './islt/server_config.prod.json';

const configMap = {
    ctm: {
        local: serverConfigCTMLocal,
        dev: serverConfigCTMDev,
        ext: serverConfigCTMPartner,
        uat: serverConfigCTMUat,
        preprod: serverConfigCTMPreprod,
        prod: serverConfigCTMProd
    },
    choo: {
        local: serverConfigCHOOLocal,
        dev: serverConfigCHOODev,
        ext: serverConfigCHOOPartner,
        uat: serverConfigCHOOUat,
        preprod: serverConfigCHOOPreprod,
        prod: serverConfigCHOOProd
    },
    islt: {
        local: serverConfigISLTLocal,
        dev: serverConfigISLTDev,
        ext: serverConfigISLTPartner,
        uat: serverConfigISLTUat,
        prod: serverConfigISLTProd
    }
};

/**
 * Returns the server config object for the specified deploy environment
 * @param {String} deployEnv - The deployment environment to get the config for
 * @param {String} theme - (optional) The white label code, if applicable. Affects the config retrieved.
 * @returns {Object} - The server config object for deployEnv
 */
export const getServerConfig = (deployEnv, theme = 'ctm') => configMap[theme][deployEnv];
